import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function selfDescibeTextValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value ?? '';
    const trimmedValue = value.trim();

    if (!trimmedValue) {
      return { required: true };
    }

    if (trimmedValue.length < 3) {
      return { minlength: { requiredLength: 3, actualLength: trimmedValue.length } };
    }

    if (trimmedValue.length > 250) {
      return { maxlength: { requiredLength: 250, actualLength: trimmedValue.length } };
    }

    return null;
  };
}